import React, { useEffect } from 'react';

export default function LightboxModal({ images, activeIndex, onClose, onPrev, onNext }) {
  const isOpen = activeIndex !== null && activeIndex !== undefined && images && images.length > 0;

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    window.addEventListener('keydown', handleKeyDown);
    // Prevent body scrolling when open
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose, onPrev, onNext]);

  if (!isOpen) {
    return null;
  }

  const currentImg = images[activeIndex];

  return (
    <div
      className="fixed inset-0 z-50 bg-slate-950/90 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in duration-200"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Billedvisning"
    >
      {/* Top controls */}
      <div className="absolute top-4 right-4 z-50 flex items-center gap-3">
        <span className="text-white/70 text-xs font-mono bg-slate-900/60 px-3 py-1.5 rounded-full border border-white/10">
          {activeIndex + 1} / {images.length}
        </span>
        <button
          type="button"
          onClick={onClose}
          className="p-2.5 rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors focus:outline-none focus:ring-2 focus:ring-white"
          aria-label="Luk billedvisning"
        >
          <i className="fa-solid fa-xmark text-xl" aria-hidden="true" />
        </button>
      </div>

      {/* Prev Button */}
      {images.length > 1 && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onPrev();
          }}
          className="absolute left-4 top-1/2 -translate-y-1/2 z-50 p-3 rounded-full bg-slate-900/60 hover:bg-slate-900 text-white border border-white/10 shadow-lg transition-all focus:outline-none focus:ring-2 focus:ring-white"
          aria-label="Forrige billede"
        >
          <i className="fa-solid fa-chevron-left text-lg" aria-hidden="true" />
        </button>
      )}

      {/* Image container */}
      <div
        className="max-w-5xl max-h-[85vh] relative flex items-center justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={typeof currentImg === 'string' ? currentImg : currentImg.src}
          alt={typeof currentImg === 'string' ? `Galleri billede ${activeIndex + 1}` : (currentImg.alt || `Galleri billede ${activeIndex + 1}`)}
          className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl select-none"
        />
      </div>

      {/* Next Button */}
      {images.length > 1 && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onNext();
          }}
          className="absolute right-4 top-1/2 -translate-y-1/2 z-50 p-3 rounded-full bg-slate-900/60 hover:bg-slate-900 text-white border border-white/10 shadow-lg transition-all focus:outline-none focus:ring-2 focus:ring-white"
          aria-label="Næste billede"
        >
          <i className="fa-solid fa-chevron-right text-lg" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
